exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid .col-4[data-v-421185ea]{padding-right:3px;padding-left:3px}", ""]);

// exports
